/** One arrival report: its filters live in the URL so a report can be bookmarked or shared. */
import { isArrivalReportSlug } from "@nexseed/shared";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { arrivalReportSearch } from "@/features/reports/api";
import { ArrivalReportView } from "@/features/reports/arrival-reports-page";

export const Route = createFileRoute("/_app/reports/arrival/$slug")({
  validateSearch: arrivalReportSearch,
  beforeLoad: ({ params }) => {
    // The Key reports' own tick opens the Daily Arrival report only.
    const { can } = useAuth.getState();
    if (
      !can("reports.arrival") &&
      !(params.slug === "daily" && can("qc.reports.daily_arrival"))
    )
      throw redirect({ to: "/reports" });
    if (!isArrivalReportSlug(params.slug))
      throw redirect({ to: "/reports/arrival" });
  },
  component: Page,
});

function Page() {
  const { slug } = Route.useParams();
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  if (!isArrivalReportSlug(slug)) return null;
  return (
    <ArrivalReportView
      key={slug}
      slug={slug}
      facilityId={selected?.id}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
